export default {"src":"/_next/static/media/axios.2bee9d12.svg","height":304,"width":1200,"blurWidth":0,"blurHeight":0};